'use strict';

function getMarketplaceData(deps) {
	var languages = deps.languages;

	function getSetting(config, setting) {
		if (!config.CHANNEL_SETTINGS || !config.CHANNEL_SETTINGS[setting]) return '';

		return config.CHANNEL_SETTINGS[setting];
	}

	return {

		getCopyrightYear: function() {
			return '&\#169; ' + (new Date(Date.now()).getFullYear());
		},

		getCurrentLanguage: function(config) {
			return languages[config.locale] || '';
		},

		getCurrentLanguageTag: function(config) {
			if (!config.locale) { return ''; }

			return config.locale;
		},

		getHomeUrl: function() {
			return '/home';
		},

		getLogInUrl: function() {
			return '/login';
		},


		getLogOutUrl: function() {
			return '/logout';
		},

		getMyAppsUrl: function() {
			return '/myapps';
		},

		getPrivacyPolicyUrl: function(config) {
			return getSetting(config, 'privacyPolicyUrl');
		},

		getSignUpUrl: function() {
			return '/signup';
		},

		getSupportUrl: function(config) {
			return getSetting(config, 'supportUrl');
		},

		getSupportEmail: function(config) {
			return getSetting(config, 'supportEmail');
		},

		getSupportPhone: function(config) {
			return getSetting(config, 'supportPhone');
		},

		getSupportContactUrl: function(config) {
			return getSetting(config, 'supportContactUrl');
		},

		getTermsUrl: function(config) {
			return getSetting(config, 'termsUrl');
		}
	};
}

module.exports = {
	getMarketplaceData: getMarketplaceData
};



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/models/marketplace-urls.js
// module id = 6
// module chunks = 0